import styled from 'styled-components';
import { themeColor } from '../../../../theme/getters';
import { H2, smallSpacedHeading } from '../../../../theme/typography';
import { media } from '../../../../theme/media';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${themeColor('primary')};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 300px;

  padding: 70px 0 140px 0;

  ${media.tablet`
    padding: 91px 0;
  `}
`;

export const Text = styled(H2)`
  &:after,
  &:before {
    content: '"';
  }
  color: ${themeColor('white')};
  margin: 0 auto 29px;
  max-width: 870px;
  width: 100%;
  padding-left: 75px;
  padding-right: 75px;
`;

export const Thumbnail = styled.img`
  max-height: 48px;
  width: auto;
  margin-bottom: 16px;
`;

export const SourceText = styled.span`
  ${smallSpacedHeading};
  color: ${themeColor('white')};
`;
